// Detektor PII do pól-teaserów (np. `note` leada). Lustro backendu
// `leads/services/pii_in_text.py` — te same wzorce i etykiety. Detekcja→blokada
// submitu po stronie klienta (twardą gwarancję daje backstop serwerowy 400).

const EMAIL = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
// Ciąg cyfr + separatory telefonu/NIP; próg cyfr sprawdzany osobno.
const NUMBER_RUN = /[+\d][\d\s.\-()]{7,}\d/g;
const MIN_NUMBER_DIGITS = 9; // telefon PL = 9, NIP = 10

// Zwraca kategorie PII wykryte w tekście (["e-mail", "numer telefonu/NIP"]); [] = czysto.
export function detectPii(text) {
  const found = [];
  if (!text) return found;
  if (EMAIL.test(text)) found.push("e-mail");
  for (const match of text.matchAll(NUMBER_RUN)) {
    if (match[0].replace(/\D/g, "").length >= MIN_NUMBER_DIGITS) {
      found.push("numer telefonu/NIP");
      break;
    }
  }
  return found;
}
